<template>
    <div>
        
        <div id="banner"></div>
        
        <div v-for="(category, type) in options">
            
            <div class="row head">
                <div class="col col-100">Beschikbare {{type}}s</div>
            </div>
            
            <div v-for="(option, index) in category">
                <div class="row row-single setting subscription"  @click="switch_subscription(option, type)">
                    <div class="avatar" v-bind:class="'avatar--'+option.icon"></div>
                    <div class="account-info">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">{{ option.name }}</div>
                                <div class="account-info__subtitle">
                                    <p>{{ option.description }}</p>
                                    <p><em>{{ option.salesLine1 }}</em></p>
                                    <p class="account-info__subtitle--large">{{ option.price }} exclusief btw p/m</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>
    </div>
</template>

<script>
    export default {
    name: 'Options',
        data () {
            
            return {
                options: {},
                subscriptionId: null
            }
        },
        
        mounted(){
            
            
        },
        
        created(){
            
            this.getOptions();
        },
        
        methods:{
            
            switch_subscription: function(option, type){
                
                var root = this.$root;
                var _this = this;
                
                var optionID = option.id;
                var catType = type;
                var subscriptionID = _this.subscriptionId;
                var bundleEffects = null;
                
                _this.$api.post('/subscription/bundle_effects', {
                    subscriptionID: subscriptionID,
                    subscriptionTypeId: optionID
                })
                .then(response => {
                    
                    bundleEffects = response.data;
                     _this.$root.ui.showDialog(
                        option.name,
                        '<ul><li>'+option.price+' exclusief btw p/m</li><li>Maandelijks opzegbaar</li><li>Gaat in per <strong>'+option.startTime+'</strong></li></ul>'
                        +'Bundels:<br/>'+bundleEffects.feedback
                        +'<br/><br/>Je kunt hierna <strong>30 dagen niet wisselen</strong> van abonnement.',
                        false,
                        {
                            0:{
                                name: 'Ik ga akkoord',
                                execute: function(){

                                    root.loading = true;

                                    _this.$api.post('/subscription/switch', {
                                        id: subscriptionID,
                                        type: catType,
                                        subscriptionTypeId: optionID
                                    })
                                    .then(response => {

                                        _this.$router.go(-1); //Back to /subscriptions
                                        root.loading = false;

                                        _this.$root.ui.showDialog(
                                            'Voltooid',
                                            'Uw abonnement is gewijzigd. Per eerste van de volgende maand zal het nieuwe abonnement ingaan.',
                                            true
                                        );
                                    })
                                    .catch(e => {

                                        root.loading = false;

                                        _this.$root.ui.showDialog(
                                            'Fout',
                                            e.response.data.message,
                                            true
                                        );
                                    })
                                }
                            },
                            1:{
                                name: 'Annuleren',
                                execute: function(){}
                            }
                        }                    
                    );
                })
                .catch(e => {
                    
                });
                
               
            },
            
            getOptions(){
                
                var id = this.$route.params.id;
                this.subscriptionId = id;
                
                this.$api.post('/subscription/options', {
                    id: id
                })
                .then(response => {

                    this.options = response.data;
                })
                .catch(e => {
                    
                }) 
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/subscriptions/Options.vue